import "./BlueShimmerText.scss";

export function BlueShimmerText({ children }: { children: React.ReactNode }) {
  return <span className="blue-shimmer-text">{children}</span>;
}
